import { createApp } from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './assets/css/style.css'
import "./assets/js/plugins/splide/splide.min.js"

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import LoaderBox from './components/LoaderBox.vue'

import DefaultSidebar from './components/DefaultSidebar.vue'
import DefaultButtonMenu from './components/DefaultButtonMenu.vue'

import WalletCardSection from './components/wallet/CardSection.vue'


import FormAddBalance from './components/forms/AddBalance.vue'
import FormWithdrawBalance from './components/forms/WithdrawBalance.vue'
import FormSellBalance from './components/forms/SellBalance.vue'
import FormSendBalance from './components/forms/SendBalance.vue'
import FormExchangeBalance from './components/forms/ExchangeBalance.vue'

import PortafolioCardSection from './components/portafolio/CardSection.vue'
import TransactionsCardSection from './components/transactions/CardSection.vue'
import HistoryCardSection from './components/history/CardSection.vue'
import HistoryItemCardSection from './components/history/ItemCardSection.vue'

import FormBanksAdd from './components/forms/BanksAdd.vue'
import FormBlockingBalance from './components/forms/BlockingBalance.vue'

import DocsTermsAndCondictions from './components/docs/TermsAndCondictions.vue'


router.beforeEach(async (to, from, next) => {
  console.log(`Navigating from ${from.fullPath} to ${to.fullPath}`);
  // await store.dispatch('loadCurrencies');
  await store.dispatch('loadNetworks');
  const checkSession = await store.dispatch('checkSession');
  console.log('router:checkSession', checkSession, checkSession.status)

  await new Promise((resolve) => {
    const checkLoading = () => {
        console.log('esperando:promise', store.getters.isLoading)
      if (!store.getters.isLoading) {
        resolve();
      } else {
        setTimeout(checkLoading, 100); // Reintentar cada 100 ms
      }
    };
    checkLoading();
  });

  console.log('continuando')

  const isAuthenticated = checkSession.status == 'connected'
  console.log('isAuthenticated', isAuthenticated)

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  console.log('requiresAuth', requiresAuth)

  const requiresGuest = to.matched.some(record => record.meta.requiresGuest)
  console.log('requiresGuest', requiresGuest)

//   console.log('record', record)
  if (requiresAuth) {
    console.log('ReqAuth...')
    if (isAuthenticated) {
      console.log('Conectado...')
      const wallet = await checkSession.userData.wallet ?? null;
      if (wallet == null && to.fullPath !== '/create-wallet') {
        console.log('from', from, to)
        // location.replace('/create-wallet')
        next({
            path: '/create-wallet',
            // query: { redirect: to.fullPath }
        })
      } else next()
    } else {
      console.log('No Conectado...')
      // location.replace('/login?redirect='+to.fullPath)
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } 
  else if (requiresGuest) {
    console.log("Pagina para no contectados")
    if (isAuthenticated) next({
        path: '/',
        query: { origin: to.fullPath }
    })
    else next()
  }
  else {
    console.log("Pagina publica")
    next()
  }
//   next();
});

const app = createApp(App)
app.use(store)
app.use(router)
app.use(VueSweetalert2)

app.component('LoaderBox', LoaderBox)
app.component('form-add-balance', FormAddBalance)
app.component('form-withdraw-balance', FormWithdrawBalance)
app.component('form-sell-balance', FormSellBalance)
app.component('form-send-balance', FormSendBalance)
app.component('form-exchange-balance', FormExchangeBalance)
app.component('wallet-card-section', WalletCardSection)
app.component('portafolio-card-section', PortafolioCardSection)
app.component('transactions-card-section', TransactionsCardSection)
app.component('history-card-section', HistoryCardSection)
app.component('history-item-card-section', HistoryItemCardSection)
app.component('default-sidebar', DefaultSidebar)
app.component('default-button-menu', DefaultButtonMenu)

app.component('form-banks-add', FormBanksAdd)
app.component('form-blocking-balance', FormBlockingBalance)

app.component('docs-terms-and-condictions', DocsTermsAndCondictions)

app.mount('#app')
